import axios from 'axios';

// Requests a short-lived step-up token by re-verifying the user's password.
// Required before actions gated by requireStepUp on the backend: order
// placement, admin account deletion/admin-role grants, refunds, and email
// change. Throws with a user-facing message on failure (wrong password,
// network error, etc.) — callers should catch and display it.
export const requestStepUpToken = async (password, accessToken) => {
  try {
    const config = {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
      withCredentials: true,
    };
    const { data } = await axios.post('/api/users/verify-password', { password }, config);
    return data.stepUpToken;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Could not verify password');
  }
};

// True when a request failed specifically because it was missing/had an
// invalid x-step-up-token — as opposed to any other 401 (bad session, etc).
export const isStepUpRequiredError = (error) =>
  error?.response?.status === 401 && error.response?.data?.message === 'Step-up verification required';
